var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPcWhSh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 61,
    viewBox: "0 0 316 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_14430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6326 17.3467H43.1934V40.705H46.6326V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2402 27.2837L47.9746 29.0259L55.2402 30.7681V27.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8417 17.3467H48.3691C53.2796 18.0113 56.4607 19.2954 58.8417 21.2376V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7966 17.3467H64.3574V40.705H67.7966V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7605 40.7049L72.6753 26.8125L70.3652 29.1225L77.9341 40.7049H81.7605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7283 17.3467C76.7283 17.3467 76.3927 20.4826 74.1602 25.3285L82.142 17.3467H76.7347H76.7283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8417 36.7173C56.4607 38.666 53.2796 40.0404 48.3691 40.705H58.8417V36.7173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.777 17.3467H278.338V40.705H281.777V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.107 17.3467H282.836C289.398 17.9468 293.076 22.5152 293.076 29.0129C293.076 35.5107 289.437 40.1049 282.836 40.705H285.107C291.573 40.705 296.741 35.8785 296.741 29.0129C296.741 22.1474 291.876 17.3467 285.107 17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.646 17.3467H256.213V40.6986H259.646V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.228 23.2056C272.228 17.9661 266.452 17.3467 264.607 17.3467H261.51C262.716 17.5983 268.582 18.2436 268.582 23.2314C268.582 29.4065 261.8 29.6066 261.8 29.6066C262.936 29.6066 264 30.1679 264.646 31.1036C268.414 36.6205 266.304 33.5297 270.782 40.6856H274.783L267.382 29.4904C269.492 29.0194 272.228 27.032 272.228 23.2121V23.2056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.412 21.9478C302.412 19.8184 303.832 18.115 306.374 17.231C302.6 17.3277 299.541 19.6507 299.541 22.9996C299.541 32.0912 312.756 27.3615 312.756 35.0917C312.756 37.7114 311.336 39.8408 308.278 40.828C312.53 40.7312 315.692 37.9115 315.692 33.8463C315.692 24.5869 302.412 29.1618 302.412 21.9542V21.9478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.466 22.0704V17.56C313.176 17.5794 310.033 17.4503 308.568 17.231C308.568 17.231 312.382 18.0956 314.466 22.0704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.477 35.8462V40.4985L305.923 40.8276C302.051 39.6597 300.444 37.0722 299.477 35.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.408 38.8144L233.416 17.3467H229.931L225.408 38.8144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.639 17.3467L215.749 20.8633L212.342 39.1177L217.33 25.8576L222.014 40.705H225.582L218.246 17.3467H214.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.682 17.3467L208.986 40.705H212.593L204.25 17.3467H200.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43922 17.3467H0V40.705H3.43922V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8851 23.2829C11.8851 28.6708 5.94875 28.9999 5.03248 29.0322C6.02618 29.0193 12.724 29.0322 12.724 34.7685C12.724 40.5049 5.16798 40.7049 4.81955 40.7049H7.32315C14.3242 40.7049 16.3438 37.9561 16.3438 34.6846C16.3438 31.8391 14.4339 29.5613 9.43959 28.987C13.2143 28.2966 15.3308 26.0963 15.3308 23.3733C15.3308 20.1018 12.853 17.353 7.32315 17.353H4.80664C6.01327 17.5853 11.8787 17.8499 11.8787 23.2894L11.8851 23.2829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.338 40.705L132.058 17.3467H128.051L143.33 40.705H147.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.742 40.705H134.298C130.839 38.2982 128.742 29.0259 128.742 29.0259V40.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.681 29.0258V17.3467H141.125C144.584 19.7535 146.681 29.0258 146.681 29.0258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.536 39.8018V29.0195H163.793C163.793 29.0195 167.264 30.0971 167.264 33.6525V39.834C167.787 39.705 169.639 39.3178 170.536 39.8018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.063 40.4663C158.791 40.8664 154.597 36.7948 154.597 28.7549C154.597 22.7476 156.32 18.2759 161.456 17.0112C155.152 17.0112 150.57 22.283 150.57 29.0195C150.57 37.6917 157.623 42.6667 165.063 40.4663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.393 21.9345V17.3468C169.058 17.3661 165.805 17.2306 164.289 17.0112C164.289 17.0112 168.767 18.1727 170.393 21.9345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1035 35.8916V40.5762L92.5496 40.9053C88.6781 39.7244 87.0714 37.124 86.1035 35.8916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.093 22.0187V17.4761C99.8025 17.4954 96.66 17.3664 95.1953 17.147C95.1953 17.147 99.0088 18.0181 101.093 22.0187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0335 21.9024C89.0335 19.7602 90.4531 18.0438 92.9954 17.1533C89.2206 17.2501 86.1621 19.5924 86.1621 22.9606C86.1621 32.1168 99.377 27.3548 99.377 35.1367C99.377 37.7758 97.9574 39.9245 94.8989 40.9117C99.1512 40.8149 102.313 37.9758 102.313 33.8849C102.313 24.5609 89.0335 29.168 89.0335 21.9089V21.9024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9784 22.4185L18.416 40.7051H22.5779L25.9784 22.4185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9009 34.175L35.2303 40.705H38.8373L30.4941 17.3467H26.8871L31.9911 31.6391L26.3516 32.8135L32.9009 34.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.894 22.4185L104.332 40.7051H108.494L111.894 22.4185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.817 34.175L121.146 40.705H124.753L116.41 17.3467H112.803L117.907 31.6391L112.268 32.8135L118.817 34.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.905 17.3467L194.015 31.6391L188.369 32.8135L194.919 34.175L197.248 40.705H200.855L192.512 17.3467H188.905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.595 40.7051L187.996 22.4185L180.434 40.7051H184.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.823 17.3467L245.933 31.6391L240.287 32.8135L246.836 34.175L249.166 40.705H252.773L244.43 17.3467H240.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.513 40.7051L239.914 22.4185L232.352 40.7051H236.513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_14430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.692,
    height: 23.9778,
    fill: "white",
    transform: "translate(0 17.0112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPcWhSh);
export default __webpack_public_path__ + "static/media/logo_pc_wh_sh.72f2f9a06d7fd47a7f1610d5af9de48d.svg";
export { ForwardRef as ReactComponent };